import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import MarketingReveal from './MarketingReveal';

const STEPS = [
  {
    number: '01',
    title: 'Search',
    description:
      'What you need and where the party is — markets and categories, not guesswork.',
  },
  {
    number: '02',
    title: 'Compare',
    description:
      'Portfolios, packages, and reviews side by side so the shortlist feels obvious.',
  },
  {
    number: '03',
    title: 'Book',
    description:
      'Lock the date with secure checkout, confirmation, and a clear path to event day.',
  },
];

/**
 * Numbered steps on a night band — each step is its own white panel.
 */
const MarketingStepsBand = () => {
  return (
    <section className="bg-m-night px-4 py-20 sm:px-6 sm:py-28">
      <MarketingReveal className="mx-auto w-full max-w-6xl">
        <h2 className="marketing-section-title mb-3 max-w-2xl text-white">
          Book in three calm steps
        </h2>
        <p className="mb-12 max-w-xl text-[1.125rem] leading-relaxed text-white/70 sm:mb-14">
          From first search to confirmed booking — the same quiet flow every time.
        </p>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 sm:gap-4">
          {STEPS.map((step) => (
            <article
              key={step.number}
              className="flex min-h-[220px] flex-col rounded-2xl bg-white px-6 py-7 sm:min-h-[260px] sm:px-7 sm:py-8"
              style={{ color: '#0a0a0a' }}
            >
              <p
                className="mb-5 text-[11px] font-medium uppercase tracking-[0.16em]"
                style={{ color: '#8a8a8a' }}
              >
                {step.number}
              </p>
              <h3
                className="mb-3 text-xl font-bold tracking-tight sm:text-[1.375rem]"
                style={{ color: '#0a0a0a' }}
              >
                {step.title}
              </h3>
              <p
                className="mt-auto text-[15px] leading-relaxed"
                style={{ color: '#6b6b6b' }}
              >
                {step.description}
              </p>
            </article>
          ))}
        </div>

        <div className="mt-12 sm:mt-14">
          <Link to="/how-it-works" className="marketing-btn marketing-btn-ghost gap-2">
            See how it works
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </MarketingReveal>
    </section>
  );
};

export default MarketingStepsBand;
